import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import banner1 from '../assets/banner1.jpg';
import banner2 from '../assets/banner2.jpeg';
import banner3 from '../assets/banner3.jpg';
import banner4 from '../assets/banner4.jpg';
import banner5 from '../assets/banner5.jpg';
import logo_icon from '../assets/logo_icon.png';
import atan_logo from '../assets/atan_logo.png';
import { MdLocationPin, MdSearch } from "react-icons/md";
import OneHotelFeed from "./OneHotelFeed";

export default function HomeBanner4(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	if(ready) {
		return (
			<div 
				className="MainBodySection"
				style={{
					paddingBottom: "50px",
					paddingTop: "50px"
				}}
			>
				<div className="container">
					<div className="row">
						<div className="col-md-12">
							<h6
								style={{
									fontSize: "52px",
									marginBottom: "40px"
								}}
								className="font-light"
							>
								About Us
							</h6>

							
						</div>

						<div className="col-md-4">
							<img
								src={atan_logo}
								style={{
									width: "100%"
								}}
							/>
						</div>

						<div className="col-md-8">
							<h6
								style={{
									fontSize: "18px",
								}}
								className="font-light"
							>
								<span className="font-semi-bold">AVAN Hotels</span> is a hotel boking platform owned by <span className="font-semi-bold">ATAN GLOBAL (T) LTD </span>.
								Our key mission for AVAN Hotels is to simplify hotel booking for everyone in Tanzania including resedents and tourists.
							</h6>

							<div className="text-end">
								<button
									className="btn text-dark font-bold"
									onClick={() => {
										appContext.navTo({
											item: 'about_us'
										})
									}}
								>
									Read More About Us....
								</button>
							</div>
						</div>

					</div>
				</div>
			</div>
		)
	} else {
		return (
			<div 
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}

	
}